import { render, staticRenderFns } from "./FeedbackNotification.vue?vue&type=template&id=efe6bebe"
import script from "./FeedbackNotification.vue?vue&type=script&lang=js"
export * from "./FeedbackNotification.vue?vue&type=script&lang=js"
import style0 from "./FeedbackNotification.vue?vue&type=style&index=0&id=efe6bebe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports